export const cottonCandyTokens = {
    tokens: {
        blendBackground: '#ff80ff',
        blendIntersection: '#003dc1',
        blendForeground: '#0073e6',
        gradientColorZero: '#45dfff',
        gradientColorOne: '#2aa1ff',
        gradientColorTwo: '#4536ff',
        gradientColorThree: '#ff79f6',
        gradientColorZeroTransparent: '#45dfff00',
        gradientColorOneTransparent: '#2aa1ff00',
        gradientColorTwoTransparent: '#4536ff00',
        gradientColorThreeTransparent: '#ff79f600'
    },
    themeTokens: {
        dark: {
            blendBackground: '#ff80ff',
            blendIntersection: '#fac7ff',
            blendForeground: '#0073e6',
            accentColor: '#f363f3'
        }
    },
    accents: {
        pink: {
            tokens: {
                accentColor: '#f363f3'
            },
            themeTokens: {
                dark: {
                    accentColor: '#ff83ff'
                }
            }
        },
        cyan: {
            tokens: {
                accentColor: '#02bcf5'
            },
            themeTokens: {
                dark: {
                    accentColor: '#09d6ff'
                }
            }
        },
        blurple: {
            tokens: {
                accentColor: '#6061f6'
            }
        },
        blue: {
            tokens: {
                accentColor: '#0073e6'
            }
        }
    }
};

//# sourceMappingURL=CottonCandy.js.map